const UserRole = {
  Admin: "admin",
  SuperAdmin: "super_admin",
  Designer: "designer",
  Manager: "manager",
  Redeem_agent: "redeem_agent",
  Deposit_agent: "deposit_agent",
};

const normalizedRoleMap = Object.entries(UserRole).reduce(
  (acc, [key, value]) => {
    acc[key.toLowerCase()] = value.toLowerCase();
    acc[value.toLowerCase()] = value.toLowerCase();
    return acc;
  },
  {}
);

export function getNormalizedRole(input) {
  if (!input || typeof input !== "string") return undefined;
  return normalizedRoleMap[input.toLowerCase()];
}

export default UserRole;
